import { useRef } from "react";
import DestinationCard from "./DestinationCard";
import "./NearbyDestinations.scss";

export default function NearbyDestinations({
  currentSlug,
  region,
  destinations,
}) {
  const carouselRef = useRef(null);

  const nearby = destinations.filter(
    (d) => d.region === region && d.slug !== currentSlug
  );

  if (!nearby.length) return null;

  const scroll = (direction) => {
    if (!carouselRef.current) return;
    const scrollAmount = 320;
    carouselRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="nearby-destinations">
      <header className="nearby-destinations__header">
        <h3>Nearby Destinations</h3>

        <div className="nearby-destinations__controls">
          <button onClick={() => scroll("left")} aria-label="Scroll left">
            ‹
          </button>
          <button onClick={() => scroll("right")} aria-label="Scroll right">
            ›
          </button>
        </div>
      </header>

      <div className="nearby-destinations__carousel" ref={carouselRef}>
        {nearby.map((destination) => (
          <DestinationCard key={destination.slug} destination={destination} />
        ))}
      </div>
    </section>
  );
}
